import React, {useState} from 'react';
import {FormattedMessage} from 'react-intl';
import {Modal} from 'react-bootstrap';
import can from '../../_common/components/Permissions/can';
import {useTransfersByAgentContext} from "../contexts/TransfersByAgentContext";
import styles from './styles.module.scss';

const PopupDeleteTransfer = ({data, canDelete}) => {
  const [show, setShow] = useState(false);
  const handleCloseModal = () => setShow(false);
  const handleShowModal = () => setShow(true);
  const isEnabled = can('full', 'transfersByAgentPage') && canDelete;
  const {paycheck} = data;
  const paycheckValue = paycheck
    ? [paycheck.date.month, paycheck.date.year].filter(Boolean).join('.')
    : '';

  const {deleteTransfer} = useTransfersByAgentContext();
  const transferID = data?._id ? data?._id : null;
  const handleDelete = () => {
    if (transferID) {
      deleteTransfer(transferID, paycheckValue);
      handleCloseModal();
    }
  };

  return (
    <>
      <div
        className={isEnabled ? 'cursor-pointer' : 'opacity-30'}
        onClick={() => {
          if (isEnabled) {
            handleShowModal()
          }
        }}
        title={'מחק העברה'}
      >
        🗑️
      </div>
      <Modal show={show} onHide={handleCloseModal}>
        <Modal.Body className={styles.modalContainer}>
          <h3 className={styles.headerText}>
            <FormattedMessage
              id={'transfersByAgent-popup-header-delete'}
              defaultMessage={'Are you sure you want to delete transfer - paycheck {paycheckValue}?'}
              values={{paycheckValue}}
            />
          </h3>
          <div className={styles.actions}>
            <button
              className={styles.btnCancel}
              onClick={handleCloseModal}
            >
              <FormattedMessage id={'button-label-no'} defaultMessage={'No'}/>
            </button>
            <button
              className={styles.btnSave}
              onClick={handleDelete}
              disabled={!transferID}
            >
              <FormattedMessage id={'button-label-yes'} defaultMessage={'Yes'}/>
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PopupDeleteTransfer;